var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`alert alert-custom alert-${_vm.infoType}`,attrs:{"role":"alert"}},[_c('div',{staticClass:"alert-icon"},[_c('i',{class:_vm.infoIcon})]),_c('div',{staticClass:"alert-text",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.infoText))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }